import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
//providers
import { AuthConnectProvider } from '@providers/account/auth-connect';
import { UtilitiesProvider } from '@providers/utilities-provider';
@Injectable({
  providedIn: 'root',
})
export class AdminSettingsGuard implements CanActivate {
  constructor(
    private router: Router,
    private authProvider: AuthConnectProvider,
    private utilitiesProvider: UtilitiesProvider,
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (
      !this.authProvider.verifySettings() ||
      !this.authProvider.verifySettingsVersioning()
    ) {
      const isBrowser = this.utilitiesProvider.getCurrentPlatform();
      if (isBrowser) {
        return true;
      } else {
        this.router.navigate(['admin-setup']);
        return false;
      }
    }
    return true;
  }
}
